// extracted by mini-css-extract-plugin
export var closeButton = "jotform-module--closeButton--9e64e";
export var modal = "jotform-module--modal--b4d36";
export var overlayJotForm = "jotform-module--overlayJotForm--76995";